import { useQuery } from '@tanstack/react-query';
import React, { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../../contex/AuthProvider';
import Loading from '../../../Home/Share/Loading/Loading';



const MyOrder = () => {

    const { user, logOut } = useContext(AuthContext);


    const { data: orders, isLoading, refetch } = useQuery({
        queryKey: ['orders'],
        queryFn: async () => {
            const res = await fetch(`https://assignment-12-server-imraniium-su.vercel.app/myOrders?email=${user?.email}`);
            const data = await res.json();
            return data;
        }
    });

    if (isLoading) {
        return <Loading></Loading>
    }


    const handleDelete = (id) => {
        const proceed = window.confirm('Are you sure, you want to cancel this ');
        if (proceed) {
            fetch(`https://assignment-12-server-imraniium-su.vercel.app/bookings/${id}`, {
                method: 'DELETE',
                headers: {
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                }
            })
                .then(res => {
                    res.json()
                })
                .then(data => {
                    refetch()
                    toast.success('Successfully delete');
                    console.log(data);
                })
        }
    }
    return (
        <div>

            <h3 className='text-3xl font-semibold mb-5 text-center'>My Products</h3>


            <div className="overflow-x-auto m-3">
                <table className="table w-full">

                    <thead>
                        <tr>
                            <th></th>
                            <th>Image</th>
                            <th>Name</th>
                            <th>Price</th>
                            <th>PayMent</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            orders &&
                            orders?.map((book, i) => <tr key={book._id}>
                                <th>{i + 1}</th>
                                <div className="mask mask-squircle w-12 h-12">
                                    <img src={book.image} alt="books" />
                                </div>
                                <td>{book.bookName}</td>
                                <td>{book.resalePrice}</td>
                                <td>
                                    {
                                        book.resalePrice && !book.paid && <Link to={`/dashboard/payment/${book._id}`}>
                                            <button className='btn btn-primary btn-sm'>Pay</button>
                                        </Link>

                                    }
                                    {
                                        book.resalePrice && book.paid && <span className='text-primary'>Paid</span>
                                    }
                                </td>

                                <td>
                                    <label>
                                        <button onClick={() => handleDelete(book._id)} className='btn btn-primary btn-sm'>Delete</button>
                                    </label>
                                </td>


                            </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MyOrder;